"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    tree_view_collapse_icon_size: index_scss_1.default.tree_view_collapse_icon_size,
    tree_view_end_icon_padding: index_scss_1.default.tree_view_end_icon_padding,
    tree_view_icon_container_space_between: index_scss_1.default.tree_view_icon_container_space_between,
    tree_view_icon_container_margin: index_scss_1.default.tree_view_icon_container_margin,
    tree_view_item_content_padding_horizontal: index_scss_1.default.tree_view_item_content_padding_horizontal,
    tree_view_item_content_padding_vertical: index_scss_1.default.tree_view_item_content_padding_vertical,
    tree_view_start_icon_padding: index_scss_1.default.tree_view_start_icon_padding,
    tree_view_text_color_focus_and_hover: index_scss_1.default.tree_view_text_color_focus_and_hover,
};
